<!-- src/components/ProductCard.vue -->
<template>
  <div
    class="border-2 transition-all duration-200 rounded-xl border-primary/20 shadow-md"
  >
    <!-- Header -->
    <div class="flex items-center justify-between gap-3 bg-productBannerColor p-2 pt-4 rounded-t-xl ">
      <img :src="product.logo" alt="logo"  class="w-10 h-10 flex-shrink-0">
      <div>
        <h3 class="label-text-medium">{{ product.title }}</h3>
        <!-- Description -->
        <p class="secondary-heading-text">{{ product.description }}</p>
      </div>
      <!-- Custom Radio -->
      <div
        @click="$emit('toggle')"
        class="w-5 h-5 border rounded-full flex items-center justify-center flex-shrink-0 cursor-pointer"
        :class="isSelected ? 'border-primary p-px' : 'border-gray-400'"
      >
        <div v-if="isSelected" class="w-3 h-3 bg-primary rounded-full"></div>
      </div>
    </div>
    <!-- Loan Amount -->
    <div class="py-3 flex flex-col items-center bg-white " :class="!isexpanded ? 'rounded-b-xl' : 'rounded-none'">
      <p class="secondary-headingColor-text">
        Approved Loan Amount
      </p>
      <p class=" text-primary font-bold text-3xl font-blogger">
        ₹ {{ product?.amountApproved?.toLocaleString('en-in') }}
      </p>
      <p v-if="!isExpanded && product?.productType === 'edi'" class="secondary-headingColor-text font-semibold py-1">
        {{ product.subDescription1 }}
      </p>
      <p v-if="isExpanded" class="secondary-headingColor-text font-semibold py-1">
        {{ product.subDescription1 }}
      </p>
    </div>
    <!-- Expandable Details -->
    <transition name="fade">
      <div v-if="isExpanded" class="px-4 pb-4 text-sm text-gray-600 space-y-1 bg-white rounded-b-xl ">
        <section v-if="product?.productType === 'bnpl'" class="bg-productBannerColor p-4 mb-4 rounded-xl">
          <div class="flex justify-between">
            <div class="flex gap-2" v-for="(data, i) in product.partnerImage.slice(0, 4)" :key="i">
              <img :class="data.name === 'bigBasket' ? 'w-16 h-6' : 'w-14 h-7'" :src="data.img" :alt="data.name"/>
            </div>
          </div>
          <p v-if="product.partnerImage.length > 4" @click.prevent="isPanelOpen = true" class="grid secondary-headingColor-text justify-center pt-1 underline text-primary">
            <span class="cursor-pointer">view all</span>
          </p>
        </section>
        <!-- <p class="secondary-headingColor-text font-semibold">You can disburse any amount from ₹40,000 to ₹ {{ product?.amountApproved?.toLocaleString('en-in') }}</p> -->
        <ul class="list-disc list-inside space-y-0.5 px-2 pb-2 secondary-headingColor-text">
          <li v-for="(point, i) in product.details.points" :key="i">
            {{ point }}
          </li>
          <li v-if="product?.productType === 'edi' && product.penalInterestPerMonth">
            <span v-if="product.interestForProductScreen">Low interest starting at {{ product.interestForProductScreen }}</span>
            <span v-else>Low interest starting at {{ product.penalInterestPerMonth }}% per month.</span>
          </li>
        </ul>
        <hr class="my-2 border-gray-200" />
        <div class="flex items-center justify-center gap-2 pt-2">
          <p class="label-text-myriad">
            NBFC Partner:
          </p>
          <img
            v-if="product.nbfcLogoUrl"
            :src="product.nbfcLogoUrl"
            alt="NBFC logo"
            class="w-8 h-4"
          />
          <p class="label-text-headingColor-myriad font-semibold">{{ product.nbfc }}</p>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <sidebar
        :isPanelOpen="isPanelOpen"
        @closeSidebarPanel="isPanelOpen = false"
        position="bottom"
        paddingTopBottom="paddingTopBottomHide"
        :panelHeight="customPanelHeight"
      >
        <section>
          <div
            class="grid justify-center text-center gap-4 border-gray-200 px-4 py-2 mb-4 pt-4"
          >
            <div @click.prevent="isPanelOpen = false" title="Close Sidebar" class="h-1 w-40 bg-textSecondary rounded-full grid justify-self-center"></div>
            <h2 class="heading-text">Marketplace & Suppliers</h2>
          </div>
          <form class="grid mx-4 gap-4">
           <section class="px-4 mb-2 rounded-xl max-h-80 overflowScrollCustom">
          <div v-if="product?.productType === 'bnpl'" class="grid grid-cols-1 gap-2 justify-between">
            <div v-for="(data, i) in product.partnerImage" :key="i">
              <div class="flex justify-between items-center">
                <img :class="data.name === 'bigBasket' ? 'w-20 h-7' : 'w-14 h-7'" :src="data.img" :alt="data.name"/>
                <p class="label-text-myriad-primary">{{ data.displayName }}</p>
              </div>
                <hr
                  v-if="i !== product.partnerImage.length - 1"
                  class="my-2 border-t border-gray-300"
                />
            </div>
          </div>
        </section>
            <p class="grid text-center text-primaryLight font-semibold font-blogger text-base">Many more partners available</p>
            <div class="flex gap-4 pb-8">
              <custom-button
                variant="primary"
                @click.prevent="isPanelOpen = false"
                class="w-full"
              >
                Ok
              </custom-button>
            </div>
          </form>
        </section>
      </sidebar>
    </transition>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue';
import CustomButton from './CustomButton.vue';

export default {
  name: "ProductCard",
  components: {
    Sidebar,
    CustomButton
  },
  data() {
    return {
      isPanelOpen: false,
      customPanelHeight: 'auto',
    };
  },
  props: {
    product: { type: Object, required: true },
    isSelected: { type: Boolean, default: false },
    isExpanded: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2ms ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: auto;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  max-height: 500px;
}

</style>
